module.exports = [{
  id: 193,
  text: "Watch \u003cstrong\u003eour first mini-documentary\u003c/strong\u003e about Uganda's new forests",
  tracking_name: 'EN_Ugandadoc',
  publish_date: (new Date()).toISOString(),
  target_url: 'https://www.youtube.com/watch?v=WxXy9lsiUPM',
  image_url: 'https://s3.amazonaws.com/static.ecosia.org/images/Notification_Uganda-newforests.jpg',
  language: 'en',
  level: 1,
}, {
  id: 190,
  text: "Our profits go towards trees, not shareholders – and we've just made that commitment legally binding. \u003cstrong\u003eLearn more\u003c/strong\u003e in our latest blogpost.",
  tracking_name: 'EN_purposefoundation',
  publish_date: '2018-10-29T09:18:33Z',
  target_url: 'https://blog.ecosia.org/trees-not-profits/',
  image_url: '',
  language: 'en',
  level: 1,
}, {
  id: 186,
  text: 'You have just planted \u003cstrong\u003e40 million trees\u003c/strong\u003e! How do we count them? \u003cstrong\u003eWatch the video\u003c/strong\u003e to find out.',
  tracking_name: 'EN_40Mtrees',
  publish_date: '2018-10-18T08:39:14Z',
  target_url: 'https://www.youtube.com/watch?v=IQh1RF1QLz8',
  image_url: 'https://s3.amazonaws.com/static.ecosia.org/images/40Mtrees_notifpic.png',
  language: 'en',
  level: 1,
}];
